var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c(_vm.toolwindow(_vm.tool.tools_id ? _vm.tool.tools_id : _vm.tool.toolId),_vm._b({ref:_vm.tool.text ? _vm.tool.text : _vm.tool.toolObj && _vm.tool.toolObj.text,tag:"component",attrs:{"idprop":this.isTrack
        ? `${_vm.getToolMasterData(_vm.tool.toolId).tooldetail.toolId}_${_vm.user.uid}`
        : `${_vm.getToolMasterData(_vm.tool.tools_id).tooldetail.toolId}_${
            _vm.tool.tools_id
          }`,"isTrack":this.isTrack},on:{"saveVideosToAT":_vm.saveVideosToAT}},'component',
      Object.assign(
        { tool: _vm.tool },
        { focus: _vm.focus },
        { user: _vm.user },
        { showTracking: _vm.showTracking }
      )
    ,false),[(_vm.focus.state == 'ontrack')?_vm._t("ontrack",function(){return [_c('b-container')]}):(_vm.focus.state == 'ondeck')?_vm._t("ondeck",function(){return [_c('b-container')]}):(_vm.focus.state == 'stationed')?_vm._t("stationed",function(){return [_c('b-container')]}):(_vm.focus.state == 'join')?_vm._t("join",function(){return [_c('b-container')]}):_vm._t("maintenance",function(){return [_c('b-container')]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }